import { Component, EventEmitter, Inject, OnInit, Output } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { WebcamImage, WebcamInitError, WebcamUtil } from 'ngx-webcam';
import { Observable, Subject } from 'rxjs';
@Component({
  selector: 'app-modal-take-photos',
  templateUrl: './modal-take-photos.component.html',
  styleUrls: ['./modal-take-photos.component.scss']
})
export class ModalTakePhotosComponent implements OnInit {
  @Output() getPicture = new EventEmitter<WebcamImage>();
  showWebcam = true;
  isCameraExist = true;
  step: number = 1;
  errors: WebcamInitError[] = [];
  webcamImage: any;
  file!: File
  onUsePhoto = new EventEmitter();
  // webcam snapshot trigger
  private trigger: Subject<void> = new Subject<void>();
  private nextWebcam: Subject<boolean | string> = new Subject<boolean | string>();

  constructor(@Inject(MAT_DIALOG_DATA) public data: any) { }


  ngOnInit(): void {
    WebcamUtil.getAvailableVideoInputs()
      .then((mediaDevices: MediaDeviceInfo[]) => {
        this.isCameraExist = mediaDevices && mediaDevices.length > 0;
      });
  }

  takeSnapshot(): void {
    this.trigger.next();
  }

  onOffWebCame() {
    this.showWebcam = !this.showWebcam;
  }

  handleInitError(error: WebcamInitError) {
    this.errors.push(error);
  }

  handleImage(webcamImage: WebcamImage) {
    this.webcamImage = webcamImage.imageAsDataUrl
    this.step = 2;
  }

  get triggerObservable(): Observable<void> {
    return this.trigger.asObservable();
  }

  get nextWebcamObservable(): Observable<boolean | string> {
    return this.nextWebcam.asObservable();
  }

  async usePhoto() {
    this.step = 3
    const blob = await (await fetch(this.webcamImage)).blob();
    let referenceId: string = '';
    if (this.data.referenceId) {
      referenceId = this.data.referenceId;
    } else {
      referenceId = this.data.item.referenceId;
    }

    const isNomina = referenceId.includes('quincenales') || referenceId.includes('mensuales');

    referenceId = isNomina
      ? referenceId.split('_').slice(1).join('_')
      : referenceId

    const counter = isNomina
      ? ((+referenceId.split('_')[1] / 2) + 1)
      : +referenceId.split('_')[1] + 1


    let nameFile = `${this.data.typeFile.replace(/\s/g, '_')}${referenceId.split('_')[1] !== '0' ? ('_' +  counter ) : ''}`
    nameFile = nameFile.replace('Comprobante', 'Comp');
    this.file = new File([blob], `${nameFile}.jpg`, { type: "image/jpeg" });
    this.onUsePhoto.emit(this.file);
  }

}
